import React from 'react';

export const GenericMusicPlayer = () => (
  <></>
);
